<template>
  <CopyToSelectInput v-model="copy_tos_proxy" @removed="removed" />
</template>

<script>
import CopyToSelectInput from "@/components/copy_to/CopyToSelectInput";
import { mapFields } from "vuex-map-fields";
export default {
  name: "SourcesCopyToSelect",
  components: { CopyToSelectInput },
  computed: {
    ...mapFields("sources", ["detailItem.copy_tos"]),
    copy_tos_proxy: {
      get() {
        return this.copy_tos ? this.copy_tos.map(item => item.id) : [];
      },
      set(newVal) {
        this.copy_tos = [
          // Keep existing items as-is
          ...this.copy_tos.filter(item => newVal.indexOf(item.id) > -1),
          // Add any new values
          ...newVal
            .filter(id => !this.copy_tos.find(item => item.id === id))
            .map(id => ({ id }))
        ];
      }
    }
  },
  methods: {
    removed(val) {
      this.copy_tos_proxy = this.copy_tos_proxy.filter(item => item !== val.id);
    }
  }
};
</script>

<style scoped></style>
